export enum ModelPjType {
  comite = 1,
  candidat = 2,
  zip = 3
}

export interface ModelPjAter {
  id?: number;
  file_name?: string;
  file?: File;
  type?: ModelPjType;
  dt_created?: Date;
}
